import { usePage } from '~/templates/pages';
import { clientSideRoutingSingleton, createInstantSearchRouting } from '../routing';
import { InstantSearchRouting } from '../types';
import { useRef } from 'react';
import { isClient } from '~/lib/helpers/isServer';
import { useIsomorphicLayoutEffect } from 'react-use';

export const useInstantSearchRouting = (): InstantSearchRouting => {
    const { data } = usePage();

    /**
     * On hook mount, we will refresh the routing to ensure that the singleton doesn't become stale.
     * We are using useLayoutEffect to ensure that the routing is updated before render.
     *
     * TODO(IMC-811): Remove once hydration mismatch errors are resolved.
     */
    useIsomorphicLayoutEffect(() => {
        clientSideRoutingSingleton.refreshRouting();
    }, []);

    /**
     * During SSR, we will use our server routing that uses the server URL. It will help build the initial state.
     */
    const serverRouting = useRef(createInstantSearchRouting(data?.plpResult?.serverUrl));

    return isClient ? clientSideRoutingSingleton.routing : serverRouting.current;
};
